/**
 * @generated SignedSource<<a8b82e77beee43da45983e319254115e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type accountFragment$data = {
  readonly businessLogoUrls: any | null;
  readonly externalId: string;
  readonly id: string;
  readonly name: string;
  readonly " $fragmentType": "accountFragment";
};
export type accountFragment$key = {
  readonly " $data"?: accountFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"accountFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "accountFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "businessLogoUrls",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "externalId",
      "storageKey": null
    }
  ],
  "type": "Account",
  "abstractKey": null
};

(node as any).hash = "ad037a2b9769fe794110111013556e01";

export default node;
